'use strict';

var _ = require('lodash');
var ConfigurationFareBuilderTransformerFactory = function ConfigurationFareBuilderTransformerFactory($rootScope, DataTransformer, momentService) {
  function ConfigurationFareBuilderTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-fare-builder-mode';
  }
  ConfigurationFareBuilderTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationFareBuilderTransformer.constructor = ConfigurationFareBuilderTransformer;
  ConfigurationFareBuilderTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationFareBuilderTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationFareBuilderTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  function getString(value) {
    return _.isNil(value) || _.isEmpty(value) ? '' : value;
  }
  function uniqueKeyGeneration(row) {
    var uniqueKeys = new Set();
    var hostCarrierList = _.has(row, 'hostCarrier') ? _.split(getString(row.hostCarrier), ',') : [''];
    var originList = _.split(getString(row.foOrigin), ',');
    var destinationList = _.split(getString(row.foDestination), ',');
    var sponsorFareTripTypeList = _.has(row, 'sponsorFareTripType') ? _.split(getString(row.sponsorFareTripType), ',') : [];
    var key;
    var commonKey = getString(row.tariffCode) + '-' + getString(row.sponsorFareRule) + '-' + getString(row.sponsorFareBrand) + '-' + getString(row.targetFareBrand) + '-' + getString(row.sponsorFareRBD) + '-' + getString(row.targetFareRBD) + '-' + getString(row.sponsorFareFamily) + '-' + getString(row.targetFBC) + '-' + getString(row.targetFareTripType) + '-';
    for (var i = 0; i < hostCarrierList.length; i++) {
      for (var j = 0; j < originList.length; j++) {
        for (var k = 0; k < destinationList.length; k++) {
          if (sponsorFareTripTypeList.length === 0) {
            key = getString(hostCarrierList[i]) + '-' + commonKey + getString(originList[j]) + '-' + getString(destinationList[k]);
            uniqueKeys.add(key);
          } else {
            for (var l = 0; l < sponsorFareTripTypeList.length; l++) {
              key = getString(hostCarrierList[i]) + '-' + commonKey + getString(originList[j]) + '-' + getString(destinationList[k]) + '-' + getString(sponsorFareTripTypeList[l]);
              uniqueKeys.add(key);
            }
          }
        }
      }
    }
    return uniqueKeys;
  }
  ConfigurationFareBuilderTransformer.prototype.transform = function (data) {
    var farebuilderList = data.domain.fareBuilderList;
    var result = [];
    var uniqueKeysFinal = new Set();
    for (var i = 0; i < farebuilderList.length; i++) {
      var fareBuilder = farebuilderList[i];
      var transformedFareBuilder = fareBuilder;
      transformedFareBuilder.hostCarrier = fareBuilder.hostCarrier;
      transformedFareBuilder.foOrigin = fareBuilder.origin;
      transformedFareBuilder.foOriginCountry = fareBuilder.originCountry;
      transformedFareBuilder.foDestination = fareBuilder.destination;
      transformedFareBuilder.foDestinationCountry = fareBuilder.destinationCountry;
      transformedFareBuilder.lastUpdatedAt = momentService.of(fareBuilder.lastUpdatedAt, momentService.FIELD.SYSTEM_CONFIGURATION_DATE);
      result.push(transformedFareBuilder);
      var keys = uniqueKeyGeneration(transformedFareBuilder);
      keys.forEach(function (key) {
        return uniqueKeysFinal.add(key);
      });
    }
    $rootScope.gridData = uniqueKeysFinal;
    return result;
  };
  return ConfigurationFareBuilderTransformer;
};
ConfigurationFareBuilderTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService'];
module.exports = ConfigurationFareBuilderTransformerFactory;